import { AGTypeError } from '@/errors';

export function objectHasAll(obj: Record<string, unknown>, keys: string[]) {
  return keys.every((key) => key in obj);
}

export function objectHasSome(obj: Record<string, unknown>, keys: string[]) {
  return keys.some((key) => key in obj);
}

export function filterObjectProps(obj: Record<string, unknown>, keepProps: string[]) {
  return Object.fromEntries(Object.entries(obj).filter(([prop]) => keepProps.includes(prop)));
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isDeepEqual(x: any, y: any): boolean {
  if (x === null || x === undefined || y === null || y === undefined) {
    return x === y;
  }
  if (x.constructor !== y.constructor) {
    return false;
  }
  if (x instanceof Function) {
    return x === y;
  }
  if (x instanceof RegExp) {
    return x.toString() === y.toString();
  }
  if (x === y || x.valueOf() === y.valueOf()) {
    return true;
  }
  if (Array.isArray(x) && x.length !== y.length) {
    return false;
  }
  if (x instanceof Date) {
    return false;
  }
  if (!(x instanceof Object)) {
    return false;
  }
  if (!(y instanceof Object)) {
    return false;
  }

  const p = Object.keys(x);
  return (
    Object.keys(y).every(function (i) {
      return p.indexOf(i) !== -1;
    }) &&
    p.every(function (i) {
      return isDeepEqual(x[i], y[i]);
    })
  );
}

export function objectsEqualSpecificFields(
  obj1: Record<string, unknown>,
  obj2: Record<string, unknown>,
  fields: string[]
) {
  const obj1OnlyKeys = filterObjectProps(obj1, fields);
  const obj2OnlyKeys = filterObjectProps(obj2, fields);

  return isDeepEqual(obj1OnlyKeys, obj2OnlyKeys);
}

export function createReverseDictorary(obj: { [key: string]: string }) {
  const returnObj: { [key: string]: string } = {};
  for (const k of Object.keys(obj)) {
    const value = obj[k];
    returnObj[value] = k;
  }
  return returnObj;
}

export function reverseRecord<T extends PropertyKey, U extends PropertyKey>(
  input: Record<T, U>
): Record<U, T> {
  return Object.fromEntries(Object.entries(input).map(([key, value]) => [value, key]));
}

export function parseIntCapped(val: string, maxVal: number | undefined | null = null, radix = 10) {
  let parsed = parseInt(val, radix);
  if (parsed < 0) throw new AGTypeError('val must be positive');
  if (maxVal !== null && maxVal !== undefined) {
    if (!Number.isInteger(maxVal)) throw new AGTypeError('maxVal must be integer');
    if (maxVal < 1) throw new AGTypeError('maxVal must be > 0');
    parsed = Math.min(parsed, maxVal);
  }
  return parsed;
}
